import type { Awaitable } from '#layers/base/public';
import type { BlockEventFunctionPayload } from '#layers/block-engine/public';

/**
 * Narrows generated block event props to the runtime event payload contract.
 */
export function blockPropsFactory<T extends Record<string, any>>(props: {
	[K in keyof T]: K extends `on${Capitalize<string>}` ? (payload: BlockEventFunctionPayload) => Awaitable<void> : T[K]
}) {
	return props;
}
